import React from 'react';

import { Text } from 'reaxl';

/**
 * Reusable component to render consitent dollar/percent symbols
 */
function WalletSymbol({ color = 'accent', weight = 'bold', size, symbol, ...rest }) {
    return (
        <Text
            color={color}
            size={size}
            weight={weight}
            {...rest}
        >
            {symbol}
        </Text>
    );
}

export default WalletSymbol;
